<script lang="ts">
  import type { Announcement } from "../types";
  import Icon from "./icon.svelte";
  import Sprite from "./sprite.svelte";

  export let announcements: Announcement[] = [];
  export let hero: string | null;
  export let href: string;
</script>

<div class="Container">
  <h1 class="Header">
    <img class="Hero" src={hero} width="240" height="240" alt="Welcome" />
  </h1>

  <h2 class="Title">Today&rsquo;s Announcements</h2>

  <ul>
    {#each announcements as announcement}
      <li>
        {#if announcement.iconSrc}
          <span class="IconSlot">
            <Icon icon={{ src: announcement.iconSrc }} fill={announcement.iconColor} />
          </span>
        {/if}
        <div class="Message">
          {@html announcement.message}
        </div>
      </li>
    {:else}
      <li>No announcements for today.</li>
    {/each}
  </ul>

  <footer>
    <a {href} class="Button">
      <Sprite icon="icon-chevron-right" />
      Continue to app
    </a>
  </footer>
</div>

<style>
  .Container {
    background: var(--theme-bg-elevation-1);
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    height: 100%;
    width: 100%;
    z-index: 1000;
  }

  .Header {
    align-items: stretch;
    background: var(--theme-color, black);
    box-shadow: inset 0 -1px 2px rgba(0, 0, 0, 0.15);
    display: flex;
    justify-content: center;
    padding-left: max(env(safe-area-inset-left), var(--outer-padding));
    padding-right: max(env(safe-area-inset-right), var(--outer-padding));
    user-select: none;
  }

  .Hero {
    display: block;
    max-height: var(--standard-hero-height);
    max-width: 100%;
    min-height: 50px;
    object-fit: contain;
  }

  .Title {
    border-bottom: 1px solid var(--color-tooling);
    font-size: 13px;
    font-weight: bold;
    letter-spacing: 0.12em;
    line-height: 1;
    padding: var(--outer-padding);
    padding-left: max(env(safe-area-inset-left), var(--outer-padding));
    padding-right: max(env(safe-area-inset-right), var(--outer-padding));
    text-transform: uppercase;
  }

  ul {
    border-width: 1px 0;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    list-style: none;
    margin: 0;
    overflow: auto;
    padding-block: 0;
    padding-left: max(env(safe-area-inset-left), var(--outer-padding));
    padding-right: max(env(safe-area-inset-right), var(--outer-padding));
  }

  li {
    border-top: 1px solid var(--color-tooling);
    align-items: flex-start;
    display: flex;
    justify-content: flex-start;
    margin: 0;
    padding: 16px 0;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px; /* align to icon */
  }

  li:first-child {
    border-top: 0;
  }

  .Message :global(*:first-child) {
    margin-top: 0;
  }

  .Message :global(*:last-child) {
    margin-bottom: 0;
  }

  .IconSlot {
    flex: 0 0 24px;
    margin-right: 16px;
  }

  .Button {
    align-items: center;
    background: black;
    border-radius: var(--border-radius-large);
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.14);
    color: white;
    display: flex;
    font-size: 12px;
    font-weight: 600;
    gap: 2px;
    justify-content: center;
    letter-spacing: 0.12em;
    line-height: 16px;
    min-height: 42px;
    padding: 0 13px 0 8px;
    position: relative;
    text-decoration: none;
    text-transform: uppercase;
  }

  footer {
    border-top: 1px solid var(--color-tooling);
    align-items: center;
    display: flex;
    flex: 0 0 auto;
    justify-content: center;
    padding: 12px 24px;
    padding-bottom: max(11px, env(safe-area-inset-bottom, 0px));
  }
</style>
